import { CampaignApprovalQueueItem } from 'api/interfaces'
import { defaultTransformFn, platformApi } from 'api/rtkQueryApi/platform/platformApi'

const campaignApprovalsTags = platformApi.enhanceEndpoints({ addTagTypes: ['CampaignApprovalQueue', 'Campaigns'] })

export const campaignApprovalsApi = campaignApprovalsTags.injectEndpoints({
  endpoints: build => ({
    getCampaignApprovalQueue: build.query<CampaignApprovalQueueItem[], void>({
      query: () => ({
        url: 'organizations/campaignApprovalQueue',
        method: 'GET',
        isContext: true
      }),
      transformResponse: defaultTransformFn,
      providesTags: () => [{ type: 'CampaignApprovalQueue' }, { type: 'Campaigns' }]
    })
  }),
  overrideExisting: false
})

export const { useGetCampaignApprovalQueueQuery } = campaignApprovalsApi
